import React from 'react';
import ReactDOM from 'react-dom';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import { Routes } from './enums';
import { Page404 } from './layouts/page404/page404';
import * as serviceWorker from './serviceWorker';
import Reports from './layouts/reports/reports';

import './normalize.css';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Switch>
        <Route exact path={Routes.PageNotFound}>
          <Page404 />
        </Route>
        <Route path={Routes.Reports}>
          <Reports />
        </Route>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
